<nav [class.disabled]="this.global.isReasonsLocked">
  <div class="barbour-logo" [ngClass]="{
      opened: this.global.isPcnPanelLocked,
      closed: !this.global.isPcnPanelLocked
    }">
    <img alt="barbour logic logo" class="barbour-logo" [src]="constants.assetsPath + '/img/rm-logo-large.png'"
      id="imgBlLogo" />
  </div>
  <div class="top-nav">
    <ul>
      <!-- Back Button -->
      <li>
        <span class="header-span" (click)="backToLetter()" *ngIf="showBackButton()">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22" height="21"
            viewBox="0 0 22 22">
            <image id="icons8-return-100" width="22" height="22"
              xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAESklEQVR4nO2d24tNURjAf+5FxpBrCjPz5Ikw41ZGXjy5hygvcolkyqvcygMPmn/AgxcKUWZQXqeICEVJHozBSO5yp47WtKZ0nHPW2nPWXmufvb5frZqay/nO/s3aa69vfWsdcEsTcB74pJv6utHxawiWzAHeAoWi9kakhJHxroSM/nY6QEzRMrtMz/i39YQOMhZsZKj2LHSgMWC6TcktK6MyVA9q8BlcbNjeplT7ADSHDjjPJJHxUWRkS0ZLyvFEjcioYRnzQwecZ0RGjcpQicQFoQPOM0lkfAGWhA44z4iMGpbRGjrgPJNUxtLQAeeZJLmpvLY3QBdwCjgIbAqVg2tK0DNibC+Bs8AWYIwPIWcy8KZrpf0AOoBVwOC0hPRk4I3WYnsC7AFGihAy1V4AO4AhrsSczsCbykO7C8x1IUTVTcmgjhMpv4BDwNBqpchjL057y01gqk8pn4HF5IPhwFg951A5uW3ACeAW8KcKKb0uliJilVIONe9YD1zSt6OkUr4Dq/EsZSFxMEGPD0kzGkrkOp9SPkUkRTEaOAB8TSDldwgpsS1QNQCXE96+qr5GsoRrZodOqdhIcbITIElPibX8Zx7wyvIa3QGGVfuCUgZkZgbw2FLKURyQpKd80P81sTFZJx1N10fNbxa5eEEpJbUb7HstpDx0kWJJ2lPe65+PjWbLgV49EATZjhDjxs+9FtfmtZ7XOEE27FRmEHDFQso+HGI7psS6x3C6rtCpdG2eu3gMTtpTYhWCrmAx/cNuxjGyLbo8dfrhppKQa3g+OCD2PYaHLZKPE9N44caiozXORfqEVSp1b1pP2f3fbwmp0mEQohbBBI9ssJhEp1Z8J/xPvcUa/awSvyekyG2DEFVgIXik3SDkuM9gBPqSiZWEXJSL5JdWg5D7nuOJngaDkO7or5BnxhuEqEyH4JERBiE/fQYjIEKyhtyyamxQfxo6wNhoNQi5FzrA2NhpEHIhdICx0W4Qcix0gLFxxyBka+gAY6Je0u/ZYqOhd6jKHVmg8kinZHqzw0SLIoddoYOMiSMWZUCTQgcZC3UWhXKqBljwxCGDjII+LE3wVGz91aLu2WmxtVB+O8JVi96h9pEIHmiz3LAzykcwsdOiV/9MQraHDjQGGi33rKsDz2RmnqFt0TGdDxNsNdD24AC1X0RIecywPVrjuqv96ULpR9s2ywG8oA8UmFbi7wiOBm+beUZ/+xLpcSNeclNqDPiWQIZKHq5MP7T4UuiHLRKFxU0dsbEmdPB5Yaxe6esc4CGYKo+1PPSbqMVjYsfpMWGp3sPRrnc7VXNMbM9AP+W0+A+F/n4hB61LTxIHhAjBmQg1Xuyvdp4hQnAi4wYwsxoRIgQnIrpdf1yF9BAGJOKRrtV1vtonQkh0GLI6y2WZTpukggjB+Ak66pPb1vpa3RMh9F2DB7oc56Q+230FMMWHAEEQBEEQBEEQBEEQyCh/ASLl/0FWGilHAAAAAElFTkSuQmCC" />
          </svg>
          <label>back</label>
        </span>
      </li>
      <!-- Home Button -->
      <li>
        <a [routerLink]="['/pcn-details']">
          <svg xmlns="http://www.w3.org/2000/svg" width="19.264" height="21" viewBox="0 0 19.264 21.843">
            <path id="Path_277" data-name="Path 277"
              d="M10.352,4.606a3.578,3.578,0,0,1,5.059,0l4.4,4.4a3.578,3.578,0,0,1,1.048,2.53v6.982A3.578,3.578,0,0,1,17.285,22.1H17.01V17.421a4.128,4.128,0,0,0-8.256,0V22.1H8.479A3.578,3.578,0,0,1,4.9,18.521V11.539a3.578,3.578,0,0,1,1.048-2.53ZM10.405,22.1h4.954V17.421a2.477,2.477,0,0,0-4.954,0ZM8.754,23.75H8.479A5.229,5.229,0,0,1,3.25,18.521V11.539a5.229,5.229,0,0,1,1.531-3.7l4.4-4.4a5.229,5.229,0,0,1,7.395,0l4.4,4.4a5.229,5.229,0,0,1,1.531,3.7v6.982a5.229,5.229,0,0,1-5.229,5.229H8.754Z"
              transform="translate(-3.25 -1.907)" fill-rule="evenodd" />
          </svg>
          <label>home</label>
        </a>
      </li>
      <!-- Letters Button -->
      <li>
        <a [routerLink]="['/letter-management']">
          <svg xmlns="http://www.w3.org/2000/svg" width="23.515" height="21" viewBox="0 0 23.515 20.076">
            <path id="Path_238" data-name="Path 238"
              d="M18.4,4.8a3.312,3.312,0,1,1,4.683,4.683l-7.635,7.635a3.311,3.311,0,0,1-1.73.913l-3.462.65A.9.9,0,0,1,9.2,17.626l.65-3.462a3.311,3.311,0,0,1,.913-1.73ZM21.8,6.076a1.505,1.505,0,0,0-2.129,0l-7.635,7.635a1.5,1.5,0,0,0-.415.786l-.407,2.164,2.164-.406a1.506,1.506,0,0,0,.787-.415L21.8,8.2A1.505,1.505,0,0,0,21.8,6.076Z"
              transform="translate(-0.534 -3.828)" fill-rule="evenodd" />
            <path id="Path_239" data-name="Path 239"
              d="M10.1,11H7.724a3.312,3.312,0,0,0-2.962,1.831L2.354,17.647A3.312,3.312,0,0,0,5.316,22.44h16.29a3.312,3.312,0,0,0,2.962-4.792L22.16,12.831q-.055-.109-.116-.213l-1.34,1.34,2.249,4.5a1.505,1.505,0,0,1-1.346,2.178H5.316a1.505,1.505,0,0,1-1.346-2.178l2.408-4.817a1.505,1.505,0,0,1,1.346-.832H8.866a2.4,2.4,0,0,1,.66-1.234Z"
              transform="translate(-2 -2.364)" fill-rule="evenodd" />
          </svg>
          <label>letters</label>
        </a>
      </li>
      <!-- Alerts Button -->
      <li #alertsPanel class="alerts-panel">
        <span class="header-span" (click)="toggleAlertsPanel()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24.704" height="21" viewBox="0 0 24.704 22.729">
            <path id="Path_227" data-name="Path 227"
              d="M12.362,4.142a2.272,2.272,0,0,1,3.632.411L20.87,13a2.272,2.272,0,0,1-1.461,3.351L7.346,19.111l-3.408-5.9Z"
              transform="translate(-0.286 -2.634)" fill="none" stroke="#000" stroke-linejoin="round"
              stroke-width="1.5" />
            <path id="Path_228" data-name="Path 228"
              d="M7.409,17.49l-2.84-4.919a1.7,1.7,0,0,0-2.952,1.7l2.84,4.919a1.7,1.7,0,1,0,2.952-1.7Z"
              transform="translate(-0.633 -1.504)" fill="none" stroke="#000" stroke-linecap="round"
              stroke-width="1.5" />
            <path id="Path_229" data-name="Path 229"
              d="M13.422,16l2.439,4.225a1.7,1.7,0,0,1-.624,2.328h0a1.7,1.7,0,0,1-2.328-.624L9.9,16.707"
              transform="translate(0.524 -0.922)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.5" />
            <path id="Path_230" data-name="Path 230" d="M18.294,5.088l.416-1.552" transform="translate(1.667 -2.617)"
              fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
            <path id="Path_231" data-name="Path 231" d="M20.294,8.366l1.552.416" transform="translate(1.939 -1.96)"
              fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
          </svg>
          <div class="number-bubble" [@bounceBubble]="bounceAlertsBubbleState" *ngIf="alerts.length > 0">
            {{ alerts.length }}
          </div>
          <label>alerts</label>
        </span>
        <alerts *ngIf="isAlertsVisible"></alerts>
      </li>
      <!-- Reports Button -->
      <li *ngIf="hasUserReportsAccess">
        <a [routerLink]="['/reports/department']">
          <svg xmlns="http://www.w3.org/2000/svg" width="26.5" height="21" viewBox="0 0 26.5 21.5">
            <rect id="Rectangle_824" data-name="Rectangle 824" width="20" height="4" rx="2"
              transform="translate(15.75 0.75) rotate(90)" fill="none" stroke="#000" stroke-width="1.5" />
            <rect id="Rectangle_825" data-name="Rectangle 825" width="11" height="5" rx="2"
              transform="translate(5.75 9.75) rotate(90)" fill="none" stroke="#000" stroke-width="1.5" />
            <rect id="Rectangle_826" data-name="Rectangle 826" width="15" height="5" rx="2"
              transform="translate(25.75 5.75) rotate(90)" fill="none" stroke="#000" stroke-width="1.5" />
          </svg>
          <label>reports</label>
        </a>
      </li>
      <!-- Settings Button -->
      <li *ngIf="hasUserAdminAccess">
        <a [routerLink]="['/admin/users']">
          <svg xmlns="http://www.w3.org/2000/svg" width="20.903" height="21" viewBox="0 0 20.903 22.076">
            <path id="Path_223" data-name="Path 223"
              d="M7.851,4.074A2.824,2.824,0,0,1,10.674,1.25h2.054a2.824,2.824,0,0,1,2.824,2.824.892.892,0,0,0,1.338.773A2.824,2.824,0,0,1,20.747,5.88l1.027,1.778a2.824,2.824,0,0,1-1.034,3.857.892.892,0,0,0,0,1.545,2.824,2.824,0,0,1,1.034,3.857L20.747,18.7A2.824,2.824,0,0,1,16.89,19.73a.892.892,0,0,0-1.338.773,2.824,2.824,0,0,1-2.824,2.824H10.674A2.824,2.824,0,0,1,7.851,20.5a.892.892,0,0,0-1.338-.773A2.824,2.824,0,0,1,2.655,18.7L1.629,16.918a2.824,2.824,0,0,1,1.034-3.857.892.892,0,0,0,0-1.545A2.824,2.824,0,0,1,1.629,7.658L2.655,5.88A2.824,2.824,0,0,1,6.513,4.846.892.892,0,0,0,7.851,4.074ZM10.674,2.79A1.283,1.283,0,0,0,9.391,4.074,2.432,2.432,0,0,1,5.743,6.18a1.283,1.283,0,0,0-1.753.47L2.962,8.428a1.283,1.283,0,0,0,.47,1.753,2.432,2.432,0,0,1,0,4.213,1.284,1.284,0,0,0-.47,1.753l1.027,1.778a1.284,1.284,0,0,0,1.753.47A2.432,2.432,0,0,1,9.391,20.5a1.283,1.283,0,0,0,1.283,1.283h2.054A1.283,1.283,0,0,0,14.011,20.5,2.432,2.432,0,0,1,17.66,18.4a1.284,1.284,0,0,0,1.753-.47l1.027-1.778a1.284,1.284,0,0,0-.47-1.753,2.432,2.432,0,0,1,0-4.213,1.283,1.283,0,0,0,.47-1.753L19.413,6.65a1.284,1.284,0,0,0-1.753-.47,2.432,2.432,0,0,1-3.648-2.106A1.283,1.283,0,0,0,12.728,2.79Z"
              transform="translate(-1.25 -1.25)" fill-rule="evenodd" />
            <path id="Path_224" data-name="Path 224"
              d="M11.529,9.79a2.31,2.31,0,1,0,2.31,2.31A2.31,2.31,0,0,0,11.529,9.79ZM7.679,12.1a3.85,3.85,0,1,1,3.85,3.85A3.85,3.85,0,0,1,7.679,12.1Z"
              transform="translate(-1.078 -1.062)" fill-rule="evenodd" />
          </svg>
          <label>settings</label>
        </a>
      </li>
      <!-- Help Button -->
      <li>
        <a [routerLink]="['/help']">
          <svg xmlns="http://www.w3.org/2000/svg" width="21.5" height="21" viewBox="0 0 21.5 21.5">
            <circle id="Ellipse_4" data-name="Ellipse 4" cx="10" cy="10" r="10" transform="translate(0.75 0.75)"
              fill="none" stroke="#000" stroke-width="1.5" />
            <path id="Path_225" data-name="Path 225" d="M12.329,13.657A3.329,3.329,0,1,0,9,10.329"
              transform="translate(-1.593 -1.952)" fill="none" stroke="#000" stroke-linecap="round"
              stroke-width="1.5" />
            <path id="Path_226" data-name="Path 226" d="M12,15.5v1.664" transform="translate(-1.264 -1.021)" fill="none"
              stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
          </svg>
          <label>help</label>
        </a>
      </li>
      <!-- Log Out Button -->
      <li>
        <!-- Click only toggles the menu now -->
        <span class="header-span" (click)="toggleProfileMenu($event)">
          <svg xmlns="http://www.w3.org/2000/svg" width="15.958" height="21" viewBox="0 0 15.958 21">
            <path id="Path_236" data-name="Path 236"
              d="M7.478,15.768c-1.222.611-1.684,1.312-1.684,1.857s.462,1.246,1.684,1.857a10.927,10.927,0,0,0,4.751.974,10.926,10.926,0,0,0,4.751-.974c1.222-.611,1.684-1.312,1.684-1.857s-.462-1.246-1.684-1.857a10.926,10.926,0,0,0-4.751-.974A10.927,10.927,0,0,0,7.478,15.768Zm-.691-1.381a12.448,12.448,0,0,1,5.441-1.137,12.449,12.449,0,0,1,5.441,1.137c1.386.693,2.538,1.794,2.538,3.239s-1.151,2.546-2.538,3.239A12.449,12.449,0,0,1,12.229,22a12.448,12.448,0,0,1-5.441-1.137C5.4,20.171,4.25,19.071,4.25,17.626S5.4,15.08,6.788,14.387Z"
              transform="translate(-4.25 -1.925)" fill-rule="evenodd" />
            <path id="Path_237" data-name="Path 237"
              d="M12.14,3.794A3.346,3.346,0,1,0,15.486,7.14,3.346,3.346,0,0,0,12.14,3.794ZM7.25,7.14a4.89,4.89,0,1,1,4.89,4.89A4.89,4.89,0,0,1,7.25,7.14Z"
              transform="translate(-4.161 -2.25)" fill-rule="evenodd" />
          </svg>
          <label>account</label>
        </span>

        <!-- Dropdown menu -->
        <div class="profile-menu dropdown-menu-right box-shadow"
            [@slideToggle]
            *ngIf="isProfileMenuVisible">

          <a class="profile-menu-item"
            *ngIf="showAccountSettings"
            [routerLink]="['/user-settings']">
            <span>settings</span>
          </a>

          <div class="dropdown-divider" *ngIf="showAccountSettings"></div>

          <a class="profile-menu-item" (click)="logout()">
            <span>logout</span>
          </a>

          <!-- if you want to keep the old debug option, you can re-add it here -->
          <!--
          <a class="question-label checkbox debug-link"
            (click)="switchConsole()"
            *ngIf="isDebugConsoleEnabled"
            [ngClass]="{ selected: isConsoleVisible }">
            <i class="checkbox-placeholder"></i>
            <span>Debug console</span>
          </a>
          -->
        </div>
      </li>
      <li class="ie-helper"></li>
    </ul>
  </div>
</nav>